import React, { useState, useEffect, useCallback } from 'react';
import axios from "../utils/axiosInstance";

const API = '';
const empty = { izina_ryumuturage: '', itariki: '', ibizayahuyenabyo: '', citizen_id: '' };

const css = `
  @keyframes fadeInUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
  @keyframes spin { to { transform:rotate(360deg); } }
  @keyframes toastIn { from { opacity:0; transform:translateY(-16px) scale(.95); } to { opacity:1; transform:translateY(0) scale(1); } }
  .ibiza-row:hover td { background:#EFF6FF !important; }
  .ibiza-edit-btn:hover { background:#DBEAFE !important; color:#1D4ED8 !important; border-color:#93C5FD !important; }
  .ibiza-del-btn:hover  { background:#FEE2E2 !important; color:#B91C1C !important; border-color:#FCA5A5 !important; }
  .ibiza-add-btn:hover  { background:#1E3A8A !important; box-shadow:0 6px 20px rgba(11,61,145,.35) !important; }
  .ibiza-input:focus    { border-color:#0B3D91 !important; box-shadow:0 0 0 3px rgba(11,61,145,.12) !important; outline:none; }
  .ibiza-search:focus   { border-color:#0B3D91 !important; box-shadow:0 0 0 3px rgba(11,61,145,.1) !important; outline:none; }
  @media(max-width:640px){
    .ibiza-table-view { display:none !important; }
    .ibiza-card-view  { display:flex !important; }
    .ibiza-header     { flex-direction:column !important; }
    .ibiza-add-btn    { width:100% !important; justify-content:center !important; }
  }
  @media(min-width:641px){
    .ibiza-table-view { display:block !important; }
    .ibiza-card-view  { display:none !important; }
  }
`;

function Toast({ msg, onClose }) {
  const ok = msg.type === 'ok';
  return (
    <div style={{ position:'fixed', top:20, right:20, left:20, zIndex:9999, display:'flex', justifyContent:'center', pointerEvents:'none' }}>
      <div style={{
        pointerEvents:'auto', display:'flex', alignItems:'center', gap:12,
        padding:'14px 20px', borderRadius:12, maxWidth:480, width:'100%',
        background: ok ? '#F0FDF4' : '#FEF2F2',
        border: `1px solid ${ok ? '#86EFAC' : '#FCA5A5'}`,
        boxShadow:'0 8px 24px rgba(0,0,0,.1)',
        animation:'toastIn .3s ease',
      }}>
        <span style={{ fontSize:'1.2rem' }}>{ok ? '✅' : '❌'}</span>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:'.82rem', color: ok ? '#166534' : '#991B1B' }}>
            {ok ? 'Byagenze neza!' : 'Ikosa!'}
          </div>
          <div style={{ fontSize:'.84rem', color: ok ? '#15803D' : '#B91C1C', marginTop:2 }}>{msg.text}</div>
        </div>
        <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:'#6B7280', padding:'2px 6px' }}>✕</button>
      </div>
    </div>
  );
}

function DeleteModal({ item, onConfirm, onCancel }) {
  return (
    <div style={{ position:'fixed', inset:0, zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:16, background:'rgba(0,0,0,.5)', backdropFilter:'blur(4px)' }} onClick={onCancel}>
      <div onClick={e => e.stopPropagation()} style={{ background:'#fff', borderRadius:16, padding:'32px 28px', maxWidth:420, width:'100%', textAlign:'center', boxShadow:'0 20px 60px rgba(0,0,0,.2)' }}>
        <div style={{ width:64, height:64, borderRadius:'50%', background:'#FEE2E2', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', fontSize:'1.8rem' }}>🗑️</div>
        <h3 style={{ color:'#111827', fontSize:'1.1rem', fontWeight:700, margin:'0 0 8px' }}>Gusiba Amakuru?</h3>
        <p style={{ color:'#6B7280', fontSize:'.88rem', margin:'0 0 12px' }}>Uragiye gusiba amakuru ya:</p>
        <div style={{ background:'#FEF2F2', border:'1px solid #FCA5A5', borderRadius:8, padding:'10px 14px', marginBottom:20 }}>
          <span style={{ color:'#B91C1C', fontWeight:700 }}>"{item?.izina_ryumuturage}"</span>
        </div>
        <p style={{ color:'#9CA3AF', fontSize:'.78rem', margin:'0 0 24px' }}>⚠️ Iyi nkuru izasibwa burundu. Ntushobora kuyigarura.</p>
        <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
          <button onClick={onCancel} style={{ flex:1, padding:'11px 20px', background:'#F9FAFB', border:'1px solid #D1D5DB', borderRadius:8, color:'#374151', cursor:'pointer', fontWeight:600, fontSize:'.88rem' }}>
            Oya, Hagarika
          </button>
          <button onClick={onConfirm} style={{ flex:1, padding:'11px 20px', background:'#DC2626', border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700, fontSize:'.88rem' }}>
            🗑️ Yego, Siba
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Ibiza() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch] = useState('');
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  // Household heads already registered under Abaturage, for the
  // auto-populate dropdown instead of hand-typing a name.
  const [householdHeads, setHouseholdHeads] = useState([]);
  useEffect(() => {
    axios.get(`${API}/isibo/household-heads`)
      .then((res) => setHouseholdHeads(Array.isArray(res.data) ? res.data : []))
      .catch(() => setHouseholdHeads([]));
  }, []);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try { const res = await axios.get(`${API}/ibiza`); setRows(res.data || []); }
    catch { setMsg({ type:'err', text:'Habaye ikosa mu gusoma amakuru.' }); }
    finally { setLoading(false); }
  };

  const handleCitizenSelect = (e) => {
    const citizenId = e.target.value;
    const head = householdHeads.find((h) => String(h.umuturage_id) === String(citizenId));
    setForm((prev) => ({
      ...prev,
      citizen_id: citizenId,
      izina_ryumuturage: head ? head.full_name : '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) { await axios.put(`${API}/ibiza/${editId}`, form); setMsg({ type:'ok', text:'Ibiza yavuguruwe neza!' }); }
      else { await axios.post(`${API}/ibiza`, form); setMsg({ type:'ok', text:'Ibiza nshya yongeyeho neza!' }); }
      setForm(empty); setEditId(null); setShowForm(false); load();
    } catch { setMsg({ type:'err', text:'Habaye ikosa. Ongera ugerageze.' }); }
  };

  const handleEdit = (row) => {
    setForm({ izina_ryumuturage: row.izina_ryumuturage, itariki: row.itariki?.slice(0,10)||'', ibizayahuyenabyo: row.ibizayahuyenabyo||'', citizen_id: row.citizen_id||'' });
    setEditId(row.id); setShowForm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!deleteTarget) return;
    const target = deleteTarget; setDeleteTarget(null);
    try { await axios.delete(`${API}/ibiza/${target.id}`); setMsg({ type:'ok', text:`"${target.izina_ryumuturage}" yasibwe neza.` }); load(); }
    catch { setMsg({ type:'err', text:'Gusiba byanze. Ongera ugerageze.' }); }
  };

  const handleDeleteCancel = useCallback(() => setDeleteTarget(null), []);

  const filtered = rows.filter(r =>
    r.izina_ryumuturage?.toLowerCase().includes(search.toLowerCase()) ||
    r.ibizayahuyenabyo?.toLowerCase().includes(search.toLowerCase())
  );

  const formatDate = (d) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('rw-RW', { year:'numeric', month:'short', day:'numeric' }); }
    catch { return d.slice(0,10); }
  };

  const inputStyle = {
    padding:'10px 14px', background:'#fff', border:'1px solid #D1D5DB',
    borderRadius:8, color:'#111827', fontSize:'.9rem', width:'100%',
    boxSizing:'border-box', transition:'all .2s', fontFamily:'inherit',
  };
  const labelStyle = { display:'block', fontSize:'.8rem', fontWeight:600, color:'#374151', marginBottom:6 };

  return (
    <>
      <style>{css}</style>
      {msg && <Toast msg={msg} onClose={() => setMsg(null)} />}
      {deleteTarget && <DeleteModal item={deleteTarget} onConfirm={handleDeleteConfirm} onCancel={handleDeleteCancel} />}

      <div style={{ maxWidth:1100, margin:'0 auto', padding:16, animation:'fadeInUp .4s ease' }}>

        {/* Header */}
        <div className="ibiza-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24, gap:12, flexWrap:'wrap' }}>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:40, height:40, borderRadius:10, background:'#0B3D91', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem' }}>🌋</div>
              <h2 style={{ fontSize:'1.35rem', fontWeight:800, color:'#0B1F3B', margin:0 }}>Ibiza</h2>
            </div>
            <p style={{ color:'#6B7280', fontSize:'.84rem', marginTop:6, marginLeft:50 }}>Kwiyandikisha mu bikorwa n'ibiza</p>
          </div>
          <button
            className="ibiza-add-btn"
            onClick={() => { setForm(empty); setEditId(null); setShowForm(true); }}
            style={{ padding:'11px 22px', background:'#0B3D91', color:'#fff', border:'none', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:'.9rem', display:'flex', alignItems:'center', gap:8, boxShadow:'0 4px 14px rgba(11,61,145,.25)', transition:'all .2s', fontFamily:'inherit' }}
          >
            ➕ Ongeraho
          </button>
        </div>

        {/* Stats */}
        <div style={{ display:'flex', gap:12, marginBottom:20, flexWrap:'wrap' }}>
          {[
            { label:'Ibiza Byose', value:rows.length, color:'#0B3D91', bg:'#EFF6FF', border:'#BFDBFE' },
            { label:'Bibonetse', value:filtered.length, color:'#166534', bg:'#F0FDF4', border:'#86EFAC' },
          ].map(s => (
            <div key={s.label} style={{ flex:'1 1 140px', background:s.bg, border:`1px solid ${s.border}`, borderRadius:12, padding:'14px 18px', display:'flex', alignItems:'center', gap:12 }}>
              <div style={{ fontSize:'1.5rem', fontWeight:800, color:s.color }}>{s.value}</div>
              <div style={{ fontSize:'.75rem', fontWeight:600, color:s.color, textTransform:'uppercase', letterSpacing:'.04em' }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Search */}
        <div style={{ display:'flex', alignItems:'center', gap:10, background:'#fff', border:'1px solid #E5E7EB', borderRadius:10, padding:'10px 14px', marginBottom:20, boxShadow:'0 1px 4px rgba(0,0,0,.06)' }}>
          <span style={{ color:'#9CA3AF', fontSize:'1rem' }}>🔍</span>
          <input
            className="ibiza-search"
            style={{ flex:1, background:'none', border:'none', outline:'none', color:'#111827', fontSize:'.9rem', fontFamily:'inherit' }}
            placeholder="Shakisha izina cyangwa ibiza..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          {search && (
            <button onClick={() => setSearch('')} style={{ background:'#F3F4F6', border:'none', borderRadius:6, color:'#6B7280', width:24, height:24, cursor:'pointer', fontSize:'.75rem', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
          )}
          <span style={{ padding:'4px 10px', background:'#EFF6FF', color:'#1D4ED8', borderRadius:999, fontSize:'.72rem', fontWeight:700, whiteSpace:'nowrap' }}>
            {filtered.length} nkuru
          </span>
        </div>

        {/* Form Modal */}
        {showForm && (
          <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', backdropFilter:'blur(4px)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={() => setShowForm(false)}>
            <div onClick={e => e.stopPropagation()} style={{ background:'#fff', borderRadius:16, padding:28, width:'100%', maxWidth:500, boxShadow:'0 20px 60px rgba(0,0,0,.2)', animation:'fadeInUp .3s ease' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:22 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:40, height:40, borderRadius:10, background: editId ? '#DBEAFE' : '#DCFCE7', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem' }}>
                    {editId ? '✏️' : '➕'}
                  </div>
                  <div>
                    <h3 style={{ color:'#0B1F3B', fontWeight:800, fontSize:'1rem', margin:0 }}>{editId ? 'Hindura Ibiza' : 'Ongeraho Ibiza Nshya'}</h3>
                    <p style={{ color:'#6B7280', fontSize:'.75rem', margin:'2px 0 0' }}>{editId ? 'Vugurura amakuru hano' : 'Uzuza amakuru yose akenewe'}</p>
                  </div>
                </div>
                <button onClick={() => setShowForm(false)} style={{ background:'#F3F4F6', border:'none', borderRadius:8, color:'#6B7280', width:34, height:34, cursor:'pointer', fontSize:'.9rem', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
              </div>

              <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
                <div>
                  <label style={labelStyle}>👤 Izina ry'Umuturage *</label>
                  <select className="ibiza-input" required value={form.citizen_id || ''} onChange={handleCitizenSelect} style={{...inputStyle, cursor:'pointer'}}>
                    <option value="">-- Hitamo umukuru w'urugo --</option>
                    {householdHeads.map((h) => (
                      <option key={h.umuturage_id} value={h.umuturage_id}>{h.full_name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>📅 Itariki *</label>
                  <input className="ibiza-input" type="date" required value={form.itariki} onChange={e => setForm({...form, itariki:e.target.value})} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>📝 Ibiza Yahuyenabyo</label>
                  <textarea className="ibiza-input" placeholder="Sobanura ibiza cyangwa ingorane zabaye..." value={form.ibizayahuyenabyo} onChange={e => setForm({...form, ibizayahuyenabyo:e.target.value})} style={{...inputStyle, minHeight:90, resize:'vertical'}} />
                </div>
                <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:4 }}>
                  <button type="button" onClick={() => setShowForm(false)} style={{ padding:'10px 20px', background:'#F9FAFB', border:'1px solid #D1D5DB', borderRadius:8, color:'#374151', cursor:'pointer', fontWeight:600, fontSize:'.88rem', fontFamily:'inherit' }}>Hagarika</button>
                  <button type="submit" style={{ padding:'10px 24px', background: editId ? '#1D4ED8' : '#16A34A', border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700, fontSize:'.9rem', fontFamily:'inherit' }}>
                    {editId ? '💾 Vugurura' : '✅ Bika'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Content */}
        {loading ? (
          <div style={{ textAlign:'center', padding:'60px 20px', color:'#6B7280' }}>
            <div style={{ width:40, height:40, border:'3px solid #E5E7EB', borderTopColor:'#0B3D91', borderRadius:'50%', animation:'spin .8s linear infinite', margin:'0 auto 14px' }} />
            <p style={{ fontSize:'.9rem' }}>Gutegereza amakuru...</p>
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign:'center', padding:'60px 24px', background:'#F9FAFB', borderRadius:16, border:'2px dashed #E5E7EB' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:12 }}>{search ? '🔍' : '🌋'}</div>
            <p style={{ fontSize:'1rem', fontWeight:700, color:'#374151', marginBottom:6 }}>{search ? 'Nta makuru abonetse' : 'Nta makuru ahari'}</p>
            <p style={{ fontSize:'.85rem', color:'#6B7280', marginBottom:20 }}>
              {search ? `Nta bisubizo bihuye na "${search}"` : 'Kanda "Ongeraho" wongere amakuru mashya.'}
            </p>
            {!search && (
              <button onClick={() => { setForm(empty); setEditId(null); setShowForm(true); }} style={{ padding:'10px 22px', background:'#0B3D91', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontWeight:700, fontSize:'.85rem', fontFamily:'inherit' }}>
                ➕ Ongeraho Ibiza
              </button>
            )}
          </div>
        ) : (
          <>
            {/* Desktop Table */}
            <div className="ibiza-table-view" style={{ overflowX:'auto', borderRadius:12, border:'1px solid #E5E7EB', boxShadow:'0 2px 8px rgba(0,0,0,.06)' }}>
              <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
                <thead>
                  <tr>
                    {['#', "Izina ry'Umuturage", 'Itariki', 'Ibiza Yahuyenabyo', 'Ibikorwa'].map(h => (
                      <th key={h} style={{ padding:'13px 16px', textAlign:'left', background:'#0B3D91', color:'#fff', fontSize:'.72rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.06em', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((row, i) => (
                    <tr key={row.id} className="ibiza-row" style={{ borderBottom:'1px solid #F3F4F6', animation:`fadeInUp .3s ease ${i*.04}s both` }}>
                      <td style={{ padding:'13px 16px', background: i%2===0 ? '#fff' : '#F9FAFB' }}>
                        <span style={{ width:26, height:26, borderRadius:6, background:'#EFF6FF', display:'inline-flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:'.75rem', color:'#1D4ED8' }}>{i+1}</span>
                      </td>
                      <td style={{ padding:'13px 16px', background: i%2===0 ? '#fff' : '#F9FAFB' }}>
                        <strong style={{ color:'#0B1F3B', fontWeight:600, fontSize:'.9rem' }}>{row.izina_ryumuturage}</strong>
                      </td>
                      <td style={{ padding:'13px 16px', background: i%2===0 ? '#fff' : '#F9FAFB' }}>
                        <span style={{ padding:'4px 10px', background:'#EFF6FF', color:'#1D4ED8', borderRadius:999, fontSize:'.75rem', fontWeight:600, whiteSpace:'nowrap' }}>{formatDate(row.itariki)}</span>
                      </td>
                      <td style={{ padding:'13px 16px', maxWidth:260, background: i%2===0 ? '#fff' : '#F9FAFB' }}>
                        <span style={{ display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden', fontSize:'.85rem', color:'#4B5563', lineHeight:1.5 }}>{row.ibizayahuyenabyo || '—'}</span>
                      </td>
                      <td style={{ padding:'13px 16px', background: i%2===0 ? '#fff' : '#F9FAFB' }}>
                        <div style={{ display:'flex', gap:6 }}>
                          <button className="ibiza-edit-btn" onClick={() => handleEdit(row)} title="Hindura" style={{ width:34, height:34, background:'#EFF6FF', border:'1px solid #BFDBFE', borderRadius:8, color:'#1D4ED8', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.85rem', transition:'all .2s' }}>✏️</button>
                          <button className="ibiza-del-btn" onClick={() => setDeleteTarget(row)} title="Siba" style={{ width:34, height:34, background:'#FEF2F2', border:'1px solid #FCA5A5', borderRadius:8, color:'#DC2626', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.85rem', transition:'all .2s' }}>🗑️</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile Cards */}
            <div className="ibiza-card-view" style={{ display:'none', flexDirection:'column', gap:10 }}>
              {filtered.map((row, i) => (
                <div key={row.id} style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:16, boxShadow:'0 1px 4px rgba(0,0,0,.06)', animation:`fadeInUp .3s ease ${i*.04}s both` }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10, flex:1, minWidth:0 }}>
                      <div style={{ width:34, height:34, borderRadius:8, background:'#EFF6FF', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:'.8rem', color:'#1D4ED8', flexShrink:0 }}>{i+1}</div>
                      <div style={{ minWidth:0 }}>
                        <div style={{ color:'#0B1F3B', fontWeight:700, fontSize:'.9rem', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{row.izina_ryumuturage}</div>
                        <span style={{ padding:'3px 8px', background:'#EFF6FF', color:'#1D4ED8', borderRadius:999, fontSize:'.7rem', fontWeight:600, display:'inline-block', marginTop:3 }}>📅 {formatDate(row.itariki)}</span>
                      </div>
                    </div>
                    <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                      <button onClick={() => handleEdit(row)} style={{ width:34, height:34, background:'#EFF6FF', border:'1px solid #BFDBFE', borderRadius:8, color:'#1D4ED8', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.85rem' }}>✏️</button>
                      <button onClick={() => setDeleteTarget(row)} style={{ width:34, height:34, background:'#FEF2F2', border:'1px solid #FCA5A5', borderRadius:8, color:'#DC2626', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.85rem' }}>🗑️</button>
                    </div>
                  </div>
                  {row.ibizayahuyenabyo && (
                    <div style={{ background:'#F9FAFB', borderRadius:8, padding:'8px 12px', color:'#4B5563', fontSize:'.82rem', lineHeight:1.5, borderLeft:'3px solid #0B3D91' }}>
                      {row.ibizayahuyenabyo}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        {/* Footer */}
        {!loading && rows.length > 0 && (
          <div style={{ display:'flex', justifyContent:'center', gap:20, marginTop:16, padding:'12px 16px', background:'#F9FAFB', borderRadius:10, border:'1px solid #E5E7EB', flexWrap:'wrap' }}>
            <span style={{ color:'#6B7280', fontSize:'.8rem' }}>
              📊 Ibigenzura byose: <strong style={{ color:'#0B3D91' }}>{rows.length}</strong>
            </span>
            {search && (
              <span style={{ color:'#6B7280', fontSize:'.8rem' }}>
                🔍 Ibisubizo: <strong style={{ color:'#16A34A' }}>{filtered.length}</strong>
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
}
